import { Box, ThemeProvider, useTheme } from "@smile2impress/components";
import React, { FC } from "react";
import { Theme, extendTheme } from "@smile2impress/themes";
import { useId } from "hooks/useId";

import { NestedThemeProviderProps } from "./NestedThemeProvider.types";

const themeRootPrefix = "theme-root";

const getValidCssClassName = (className: string) =>
    className.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, "").toLowerCase();

const getCssRoot = (id: string) =>
    `${themeRootPrefix}-${getValidCssClassName(id)}`;

const getIdSelector = (id: string) => `#${id}`;

// TODO: move to DS
export const NestedThemeProvider: FC<NestedThemeProviderProps> = ({
    children,
    theme,
    withoutWrapper,
}) => {
    const id = useId();
    const themeRootId = getCssRoot(id);
    const baseTheme = useTheme<Theme>();
    const nestedTheme = extendTheme(baseTheme, theme);

    return (
        <ThemeProvider
            theme={nestedTheme}
            cssVarsRoot={getIdSelector(themeRootId)}
        >
            {withoutWrapper ? (
                React.isValidElement<HTMLElement>(children) &&
                React.cloneElement(children, { id: themeRootId })
            ) : (
                <Box id={themeRootId}>{children}</Box>
            )}
        </ThemeProvider>
    );
};
